// extracted by mini-css-extract-plugin
module.exports = {"input__full-width":"VerifyEmail_input__full-width__393-d","inputFullWidth":"VerifyEmail_input__full-width__393-d"};